var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-toggle",on:{"click":_vm.toggleTheme}},[_c('transition',{attrs:{"name":"theme-toggle","mode":"out-in"}},[(_vm.isDarkMode)?_c('div',{key:"sun",staticClass:"toggle-icon moon"},[_c('i',{staticClass:"el-icon-moon"})]):_c('div',{key:"moon",staticClass:"toggle-icon sun"},[_c('i',{staticClass:"el-icon-sunny"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }